import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Loader from "../../shared/loader";
import Modal from 'react-bootstrap/Modal';
import Swal from "sweetalert2";
import moment from 'moment';
import ViewPurchase from "./view";
import Pagination from "../../shared/pagination";

const Purchase = () => {
  const [partyData, setPartyData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [purchaseId, setPurchaseId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = 30;
  const handleClose = () => setShow(false);

  const getParty = (page = 1) => {
    setLoading(true);
    axios.post(API_URL.PURCHASE_LIST, {
      page: page,
      limit: itemsPerPage,
    }).then(
      (res) => {
        if (res.data.status === 1) {
          res.data.data.data.map(item => item.date = moment(item.date).format('DD/MM/YYYY'));
          setPartyData(res.data.data.data);
          const total = res.data.data.total || 0;
          setTotalPages(Math.ceil(total / itemsPerPage));
          setTotalCount(total);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,

        });
      }
    );
  };

  const viewPurchase = (row) => {
    setPurchaseId(row.id);
    setShow(true);
  }

  const deleteParty = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Purchase ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.PURCHASE_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              toast.success("Delete Successfully", { autoClose: 3000 });
              getParty(currentPage); // reload current page
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  useEffect(() => {
    getParty(currentPage);
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getParty(page);
  };
  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>
            Purchase
            <small className="me-2">({totalCount})</small>
          </h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/purchase/add"} className="btn btn-primary">
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Add
              Purchase
            </Link>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-0">
            {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table">
                    <thead className="">
                      <tr>
                        <th>Invoice No</th>
                        <th>Invoice Date</th>
                        <th>Amount</th>
                        <th>Qty</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {partyData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td>{row.invoice_no}</td>
                            <td>
                              {row.date}
                            </td>
                            <td>{row.total_amount}</td>
                            <td>{row.total_qty}</td>
                            <td>
                              {/* <button type="button" onClick={() => viewPurchase(row)} className="btn btn-sm btn-success mr-2">
                                View
                              </button> */}
                              <Link
                                to={"/purchase/edit/" + row.id}
                                className="btn btn-sm btn-secondary mr-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </Link>
                              <button
                                onClick={() => deleteParty(row)}
                                className="btn btn-sm btn-danger"
                              >
                                <i className="fa fa-trash me-1"></i> Delete
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  {totalPages > 1 && (
                    <div className="d-flex justify-content-center my-3">
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={show}
        size={'xl'}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-right"><i className="simple-icon-close text-danger"style={ {fontSize: "23px",cursor:"pointer"}} onClick={handleClose} ></i></div>
          {purchaseId && <ViewPurchase id={purchaseId}></ViewPurchase>}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Purchase;
